import { klemmergBaseUrl } from "@/api/base/urls";

const klemmergUrl = {
  createJob: `${klemmergBaseUrl}/job`,
  getPrinters: `${klemmergBaseUrl}/printer`,
  getLastUserJob: `${klemmergBaseUrl}/job/by-author`,
};

export { klemmergUrl };
